import { CompanyLocation } from '../types/enums';
import configAU from '../../public/static/configAU.json';
import configUK from '../../public/static/configUK.json';

export const getCountrySpecificConfig = (packageType?: string) => {
  const country = new URLSearchParams(window.location.search).get('country');

  if ((packageType && packageType === CompanyLocation.AU) || (country && country === CompanyLocation.AU)) {
    return {
      ...configAU,
      country: CompanyLocation.AU
    };
  }

  return { ...configUK, country: CompanyLocation.GB };
};
